import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGenericServiceResponse } from '../interfaces/IServiceResponse';
import { environment } from '../../environments/environment';
import {
  ICareTeamTemplate,
  ICareTeamTemplateListItem,
} from '../interfaces/ICareTeamTemplate';
import { ICareTeamTemplateDropdownData } from '../interfaces/ICareTeamTemplateDropdownData';
import { IAddCareTeamTemplate } from '../interfaces/IAddCareTeamTemplate';
import { ISearchCareTeamTemplate } from '../interfaces/ISearchCareTeamTemplate';

@Injectable({ providedIn: 'root' })
export class CareTeamTemplateService {
  constructor(private _http: HttpClient) {}

  getCareTeamTemplates(
    pageNumber: number,
    pageSize: number,
    searchParams?: ISearchCareTeamTemplate
  ): Observable<IGenericServiceResponse<ICareTeamTemplateListItem[]>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    let params = new HttpParams();
    if (searchParams?.name) {
      params = params.set('name', searchParams.name);
    }
    if (searchParams?.participantName) {
      params = params.set('participantName', searchParams.participantName);
    }
    searchParams?.careTeamCategoryIds?.forEach((id) => {
      params = params.append('careTeamCategoryIds', id);
    });
    searchParams?.careTeamRoleIds?.forEach((id) => {
      params = params.append('careTeamRoleIds', id);
    });

    return this._http.get<
      IGenericServiceResponse<ICareTeamTemplateListItem[]>
    >(`${environment.BACKEND_URL}CareTeamTemplates/${pageNumber}/${pageSize}`, {
      headers: headers,
      params: params,
    });
  }

  getCareTeamTemplateById(
    id: number
  ): Observable<IGenericServiceResponse<ICareTeamTemplate>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this._http.get<IGenericServiceResponse<ICareTeamTemplate>>(
      `${environment.BACKEND_URL}CareTeamTemplates/${id}`,
      {
        headers: headers,
      }
    );
  }

  addCareTeamTemplate(
    requestBody: IAddCareTeamTemplate
  ): Observable<IGenericServiceResponse<ICareTeamTemplate>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this._http.post<IGenericServiceResponse<ICareTeamTemplate>>(
      `${environment.BACKEND_URL}CareTeamTemplates`,
      requestBody,
      {
        headers: headers,
      }
    );
  }

  updateCareTeamTemplate(
    id: number,
    requestBody: IAddCareTeamTemplate
  ): Observable<IGenericServiceResponse<ICareTeamTemplate>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this._http.put<IGenericServiceResponse<ICareTeamTemplate>>(
      `${environment.BACKEND_URL}CareTeamTemplates/${id}`,
      requestBody,
      {
        headers: headers,
      }
    );
  }

  deleteCareTeamTemplate(id: number): Observable<IGenericServiceResponse<any>> {
    return this._http.delete<IGenericServiceResponse<any>>(
      `${environment.BACKEND_URL}CareTeamTemplates/${id}`,
      {}
    );
  }

  getDropdownData(): Observable<
    IGenericServiceResponse<ICareTeamTemplateDropdownData>
  > {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this._http.get<
      IGenericServiceResponse<ICareTeamTemplateDropdownData>
    >(`${environment.BACKEND_URL}CareTeamTemplates/DropdownData`, {
      headers: headers,
    });
  }
}